import { render, staticRenderFns } from "./EditIndexPart.vue?vue&type=template&id=2f22c16c&scoped=true&"
import script from "./EditIndexPart.vue?vue&type=script&lang=js&"
export * from "./EditIndexPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f22c16c",
  null
  
)

export default component.exports